import axios from "./axios";
import { useUserStoreHook } from "@/stores/user";

export function getUserInfo() {
  return new Promise((resolve, reject) => {
    axios.get("/user/info", {
        notShowError: false,
      }).then((res) => {
        const store = useUserStoreHook();
        store.setUserInfo(res.data);
        resolve(res.data);
      }).catch((err) => {
        reject(err);
      });
  });
}

export function getUserInfoIfNeeded() {
  const store = useUserStoreHook();
  // console.log('store.userInfo',store.userInfo)
  if (store.userInfo) {
    // 如果 userInfo 存在，直接返回一个 resolved 的 Promise
    return Promise.resolve(store.userInfo);
  }

  // 否则调用 getUserInfo 并返回 Promise
  return getUserInfo();
}


export function loginOut() {
  const store = useUserStoreHook();
  store.loginOut();
}
